import { CustomAutocompletePrediction } from '@bridebook/web/app-shared/lib/search/types';

export const isCustomAutocompletePrediction = (
  data: Record<string, any>,
): data is CustomAutocompletePrediction => data.custom;
